import { render, staticRenderFns } from "./Black2.vue?vue&type=template&id=bb48329e"
import script from "./Black2.vue?vue&type=script&lang=js"
export * from "./Black2.vue?vue&type=script&lang=js"
import style0 from "./estilo2.styl?vue&type=style&index=0&prod&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports